module.exports = __webpack_public_path__ + "static/img/solutionDetailPic12.0380e0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic12.jpg
// module id = nGUo
// module chunks = 1